module.exports = __webpack_public_path__ + "static/media/backyard-logo.df1812b2.png";